import React from 'react';
import { usePricingFigures, usd } from '../../../hooks/usePricingFigures';
const head = 'text-[11.5px] font-bold uppercase tracking-[0.12em] text-[#c5cdd3] whitespace-nowrap';
const note = 'mt-2 text-[12.5px] leading-snug text-[#aab4bc]';
interface Fee {
  label: string;
  value: string;
  unit?: string;
  sub: string;
  /** Promo deadline, emphasized under the note. */
  deadline?: string | null;
  accent?: boolean;
}

/**
 * Four figures side by side, projected hires largest. Every label and figure
 * sits on the same top line, so notes of different lengths never shift the
 * figures out of alignment.
 */
export function PricingFigureRow({
  includeLeader
}: {
  includeLeader: boolean;
}) {
  const f = usePricingFigures(includeLeader);
  const fees: Fee[] = [...(f.showImplementation ? [{
    label: 'Implementation',
    value: usd(f.implementation),
    sub: f.implementationNote,
    deadline: f.promoDeadlineText
  }] : []), {
    label: 'Monthly service',
    value: usd(f.monthly),
    unit: '/ mo',
    sub: f.monthlyNote
  }, {
    label: 'Placement bonus',
    value: usd(f.bonus),
    unit: '/ rep',
    sub: f.bonusNote,
    accent: true
  }];
  return <div data-id="element-851" data-mp="3mc8e7lu26g81">
      <div className="grid items-start gap-6" style={{
      gridTemplateColumns: `repeat(${fees.length}, minmax(0, 1fr)) 1.3fr`
    }} data-id="element-852" data-mp="3mci5rdur4vfu">
        {fees.map(fee => <div key={fee.label} data-id="element-853" data-mp="hwpab2i0ytet">
            <div className={head} data-id="element-854" data-mp="muqwhwaqz8ui">{fee.label}</div>
            <div className={`brief-display mt-2 text-[38px] font-extrabold leading-none whitespace-nowrap ${fee.accent ? 'text-[#6fd6b0]' : 'text-white'}`} data-id="element-855" data-mp="muijm4emk3jb">
              {fee.value}
              {fee.unit && <span className={`ml-1 text-[16px] font-bold ${fee.accent ? 'text-[#6fd6b0]' : 'text-[#c5cdd3]'}`} data-id="element-856" data-mp="10ujl9m2prezu">
                  {fee.unit}
                </span>}
            </div>
            <div className={note} data-id="element-857" data-mp="1bg6foqgdalwc">{fee.sub}</div>
            {fee.deadline && <div className="mt-1 text-[14px] font-bold leading-snug text-[#6fd6b0] whitespace-nowrap" data-id="element-858" data-mp="1be29u2ywrctf">
                {fee.deadline}
              </div>}
          </div>)}
        <div className="self-stretch border-l border-[#33404a] pl-6" data-id="element-859" data-mp="11k3cridoyj8c">
          <div className={head} data-id="element-860" data-mp="wk777epcijqo">Projected hires / mo</div>
          <div className="brief-display mt-2 text-[56px] font-extrabold leading-[0.85] text-[#6fd6b0] whitespace-nowrap" data-id="element-861" data-mp="rre2urxshdf4">
            {f.hiresLow}–{f.hiresHigh}
          </div>
          <div className={note} data-id="element-862" data-mp="ir7vlnsop9oe">
            {usd(f.costLow)}–{usd(f.costHigh)} all-in per hire, incl. est. bonuses
          </div>
        </div>
      </div>
      <p className="mt-4 pt-3 border-t border-[#33404a] text-[13.5px] text-[#aab4bc]" data-id="element-863" data-mp="dqtoc7ywq3rf">
        Recommended ad spend{' '}
        <span className="font-bold text-white" data-id="element-864" data-mp="8v4tghxu1b1g">{usd(f.adSpend)} / mo</span>, {f.adsNote},
        not to D2D HIRE.
      </p>
    </div>;
}